var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"page-loader"},[_c('div',{staticClass:"loader"}),_c('img',{staticClass:"loader-logo",attrs:{"src":require("../assets/logo.png"),"alt":"ZL"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }